import { Directive, computed, input } from '@angular/core';
import imageManifest from '../constants/image-manifest.json';

interface ImageAsset { src: string; srcset: string; width: number; height: number; }
const images = imageManifest as Record<string, ImageAsset>;

@Directive({
  selector: 'img[sohImage]',
  host: {
    '[attr.src]': 'sohImage()', '[attr.srcset]': 'image()?.srcset ?? null',
    '[attr.sizes]': 'sizes()', '[attr.width]': 'image()?.width ?? null',
    '[attr.height]': 'image()?.height ?? null', 'decoding': 'async'
  }
})
export class ResponsiveImageDirective {
  readonly sohImage = input.required<string>();
  readonly sizes = input('100vw');
  readonly image = computed(() => images[this.sohImage()]);
}
